import React, { Component } from "react";

export default class BlogsImg extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <svg
        id="email-section-illustration"
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 808.41844 712.52788"
      >
        <title>Email Section</title>
        <path
          d="M714.96678,737.11091l-1.98354-27.58851a89.24423,89.24423,0,0,0-41.89885-9.39586c20.43166,15.79292,18.7951,47.3576,32.9451,68.95961a53.68053,53.68053,0,0,0,40.02768,23.72162l17.00408,9.78252A89.95167,89.95167,0,0,0,740.117,730.24435,86.88782,86.88782,0,0,0,723.74913,715.849C720.03237,726.52007,714.96678,737.11091,714.96678,737.11091Z"
          transform="translate(-195.79078 -93.73606)"
          fill="#f2f2f2"
        />
        <path
          d="M613.68122,806.26394h389.281a1.247,1.247,0,0,0,0-2.494H613.6812a1.247,1.247,0,0,0,0,2.494h0Z"
          transform="translate(-195.79078 -93.73606)"
          fill={theme.secondaryText}
        />
        <path
          d="M365.83032,508.54938v.53376h.372A5.30968,5.30968,0,0,1,365.83032,508.54938Zm2.863-226.33756a192.99845,192.99845,0,0,0-40.00088,117.86763q.00874,9.7374.95408,19.19978c.09714,1.08373.21008,2.16746.35619,3.235a192.54566,192.54566,0,0,0,32.81915,87.36145c.695,1.019,1.40663,2.02188,2.119,3.02473a193.84342,193.84342,0,0,0,26.308,29.851c78.65278,72.62736,201.28967,67.74281,273.917-10.91,1.116-1.18075,2.18379-2.37773,3.235-3.57467a193.66531,193.66531,0,0,0,8.4919-246.05488c-.82534-1.08373-1.66578-2.16745-2.5392-3.235q-2.8714-3.61515-5.9527-7.08468c-1.05122-1.197-2.119-2.39393-3.235-3.5747A193.51344,193.51344,0,0,0,522.793,205.97881c-1.86,0-3.70415.03236-5.54832.08088q-1.84428.04844-3.68757.14557a193.74871,193.74871,0,0,0-142.32467,72.77158c-.87352,1.06756-1.71386,2.15128-2.5392,3.235Zm-2.491,226.87132a5.327,5.327,0,0,1-.3721-.53376v.53376h.3721Z"
          transform="translate(-195.79078 -93.73606)"
          fill={theme.body}
        />
        <path
          d="M364.47187,506.55988l.5497-1.11608,41.18172-82.92951v-.01616l1.60171-3.21885v-.01616L475.83658,282.2119v-.01617l1.60171-3.21884.01579-.01617,34.45334-69.43951,1.64989-3.31589q1.84428-.097,3.68756-.14557l-1.6333,3.29972-34.54969,69.60125v.01617l-1.60171,3.21884v.01617L409.64839,422.83782l-.0158.01616-41.18172,82.9942-1.61751,3.235-.25905.5337-1.6333,3.28354c-.7124-1.00285-1.424-2.00569-2.119-3.02473Z"
          transform="translate(-195.79078 -93.73606)"
          fill={theme.dark}
        />
        <path
          d="M408.95327,419.27921v3.235H330.00273c-.14611-1.06756-.25905-2.15128-.35619-3.235Z"
          transform="translate(-195.79078 -93.73606)"
          fill={theme.dark}
        />
        <path
          d="M531.64654,444.51422v-3.235h78.95053c.14611,1.06756.25905,2.15128.3562,3.235Z"
          transform="translate(-195.79078 -93.73606)"
          fill={theme.dark}
        />
        <path
          d="M597.6824,433.24335h3.235v78.95053c-1.06756.14611-2.15129.25905-3.235.3562Z"
          transform="translate(-195.79078 -93.73606)"
          fill={theme.dark}
        />
        <path
          d="M676.89288,282.21182c-.82537-1.08374-1.66571-2.16748-2.53918-3.23505h-5.95276v-7.08472c-1.05121-1.1969-2.1189-2.3938-3.235-3.57464v10.65936H371.23255c-.87354,1.06757-1.71387,2.15131-2.53919,3.23505H665.166V531.84133c1.116-1.18078,2.18377-2.37774,3.235-3.57464V282.21182Z"
          transform="translate(-195.79078 -93.73606)"
          fill={theme.dark}
        />
        <rect
          x="170.03564"
          y="412.11017"
          width="300.9565"
          height="3.23501"
          fill={theme.dark}
        />
        <path
          d="M365.83032,508.54938v.53376h.372A5.30968,5.30968,0,0,1,365.83032,508.54938Zm2.863-226.33756a192.99845,192.99845,0,0,0-40.00088,117.86763q.00874,9.7374.95408,19.19978c.09714,1.08373.21008,2.16746.35619,3.235a192.54566,192.54566,0,0,0,32.81915,87.36145c.695,1.019,1.40663,2.02188,2.119,3.02473a193.84342,193.84342,0,0,0,26.308,29.851c78.65278,72.62736,201.28967,67.74281,273.917-10.91,1.116-1.18075,2.18379-2.37773,3.235-3.57467a193.66531,193.66531,0,0,0,8.4919-246.05488c-.82534-1.08373-1.66578-2.16745-2.5392-3.235q-2.8714-3.61515-5.9527-7.08468c-1.05122-1.197-2.119-2.39393-3.235-3.5747A193.51344,193.51344,0,0,0,522.793,205.97881c-1.86,0-3.70415.03236-5.54832.08088q-1.84428.04844-3.68757.14557a193.74871,193.74871,0,0,0-142.32467,72.77158c-.87352,1.06756-1.71386,2.15128-2.5392,3.235Zm-35.4398,140.3024c-.14532-1.06751-.25826-2.15131-.372-3.23506a190.89733,190.89733,0,0,1,39.88793-137.06741c.85693-1.08373,1.71465-2.16745,2.604-3.235a190.62139,190.62139,0,0,1,136.53388-69.45567c1.22883-.06471,2.45854-.12941,3.704-.16175q3.566-.14557,7.18163-.14557a190.32405,190.32405,0,0,1,142.37286,63.89146c1.116,1.22932,2.19958,2.45862,3.235,3.72027.631.7117,1.22892,1.42341,1.81179,2.15128.88931,1.06756,1.74624,2.15129,2.604,3.235a190.48085,190.48085,0,0,1-4.41576,241.12154c-1.03543,1.26165-2.119,2.49092-3.235,3.72024a190.64292,190.64292,0,0,1-33.08946,29.43812c-86.2606,60.37228-205.13,39.38568-265.50219-46.87483-.12953-.17785-.25905-.3558-.372-.5337a5.30968,5.30968,0,0,1-.372-.53376q-.70341-.99484-1.35845-1.98955a189.16712,189.16712,0,0,1-31.21833-84.04556Zm32.94878,86.56892a5.327,5.327,0,0,1-.3721-.53376v.53376h.3721Z"
          transform="translate(-195.79078 -93.73606)"
          fill={theme.secondaryText}
        />
        <path
          d="M746.34016,608.55752h-193.65a8.94094,8.94094,0,0,1-8.9309-8.9309v-94.357a8.94094,8.94094,0,0,1,8.9309-8.9309h193.65a8.941,8.941,0,0,1,8.9309,8.9309v94.357A8.941,8.941,0,0,1,746.34016,608.55752Z"
          transform="translate(-195.79078 -93.73606)"
          fill="#cacaca"
        />
        <path
          d="M661.04108,600.96511c-42.41065,0-86.6333-.40527-103.1333-.668a8.32,8.32,0,0,1-8.14844-8.28613V505.27664a2.94069,2.94069,0,0,1,2.93018-2.9375H746.33405a2.94048,2.94048,0,0,1,2.937,2.92968v58.84766a36.714,36.714,0,0,1-36.0957,36.57031C697.79743,600.887,679.588,600.96511,661.04108,600.96511Z"
          transform="translate(-195.79078 -93.73606)"
          fill="#e4e4e4"
        />
        <path
          d="M726.34755,556.56087H568.78332a4.96271,4.96271,0,0,1-4.66512-3.28967l-17.83332-50.03238a4.95275,4.95275,0,0,1,4.65817-6.61548l196.95789-.27483h.00688a4.95265,4.95265,0,0,1,4.55209,6.90351l-.27-.11561.27.11561-21.56028,50.30721A4.94669,4.94669,0,0,1,726.34755,556.56087Z"
          transform="translate(-195.79078 -93.73606)"
          fill="#cacaca"
        />
        <path
          d="M614.45231,591.23677H560.11973a5.04768,5.04768,0,0,1,0-10.09535h54.33258a5.04768,5.04768,0,0,1,0,10.09535Z"
          transform="translate(-195.79078 -93.73606)"
          fill="#cacaca"
        />
        <circle cx="453.4306" cy="462.82481" r="12.33819" fill={theme.dark} />
        <path
          d="M258.161,119.24859a139.8087,139.8087,0,0,1,194.80744,33.80816c44.45868,63.13047,89.06955,228.67432,57.57876,324.575-93.92941-99.21546-238.233-109.52515-286.19436-163.57575C173.1045,256.301,195.03059,163.70733,258.161,119.24859Z"
          transform="translate(-195.79078 -93.73606)"
          fill={theme.imageHighlight}
        />
        <circle cx="144.77165" cy="122.8712" r="45.59621" fill={theme.body} />
        <circle
          cx="353.30112"
          cy="403.68803"
          r="29.86454"
          fill={theme.imageHighlight}
        />
        <path
          d="M291.77986,206.0863a45.59533,45.59533,0,1,0,78.74981,45.98049,45.58953,45.58953,0,0,1-69.41687-57.28918A45.59524,45.59524,0,0,0,291.77986,206.0863Z"
          transform="translate(-195.79078 -93.73606)"
          fill="#231f20"
          opacity="0.2"
          style={{ isolation: "isolate" }}
        />
        <path
          d="M224.2671,314.271c47.9613,54.05057,192.265,64.36029,286.19434,163.57574a193.39447,193.39447,0,0,0,6.7514-27.75854C423.33015,359.89226,287.06,348.49349,240.72059,296.271c-41.47448-46.7403-35.01831-116.29408,2.412-164.69008C191.7975,179.16676,177.30287,261.34414,224.2671,314.271Z"
          transform="translate(-195.79078 -93.73606)"
          fill="#231f20"
          opacity="0.2"
          style={{ isolation: "isolate" }}
        />
        <path
          d="M820.41976,505.24113,801.05649,499.343c-8.42863,10.16294-15.41749,39.60186-15.41749,39.60186L759.13763,582.009A8.93655,8.93655,0,1,0,771.88,590.77118l40.10863-48.69278Z"
          transform="translate(-195.79078 -93.73606)"
          fill="#ffb6b6"
        />
        <path
          d="M820.04873,509.94074l3.57869-29.312L815.6062,467.233a16.43321,16.43321,0,0,0-15.45224-7.88124h0a16.39445,16.39445,0,0,0-14.89927,16.70464c.30089,12.59836,2.28566,28.5296,10.03108,32.88346l.07849.04412Z"
          transform="translate(-195.79078 -93.73606)"
          fill={theme.imageHighlight}
        />
        <polygon
          points="678.959 681.066 667.348 686.67 640.203 644.55 657.341 636.278 678.959 681.066"
          fill="#ffb6b6"
        />
        <path
          d="M881.00666,786.71729l-35.70683,17.236-.218-.45156a15.43341,15.43341,0,0,1,7.18868-20.60688l.00086-.00042,4.13348-8.09669,14.558-.92582,3.117-1.5046Z"
          transform="translate(-195.79078 -93.73606)"
          fill={theme.dark}
        />
        <polygon
          points="592.527 696.767 579.634 696.766 573.5 647.033 592.53 647.034 592.527 696.767"
          fill="#ffb6b6"
        />
        <path
          d="M788.77225,803.9533l-39.64918-.00149v-.50143a15.43341,15.43341,0,0,1,15.43256-15.43232h.001l7.24243-5.49449,13.51278,5.49532,3.46111.00012Z"
          transform="translate(-195.79078 -93.73606)"
          fill={theme.dark}
        />
        <path
          d="M775.53969,559.85,760.7649,661.73705l4.02093,13.4064-5.27629,9.49491,7.74835,71.46417-3.14522,6.92449,8.78773,5.41965h17.88176l.949-75.48987,4.41711-11.08355v-6.10839l8.99195-46.032,2.07412,71.65964,2.87077,5.53736c10.69335,24.26152,25.09819,32.20527,35.28181,50.34019l17.88251-9.68637-.375-7.22386c3.59249-1.81886-5.39371-7.13482-6.25721-11.06786l-1.564-7.04184-10.43147-21.608-.39808-7.60953,2.85494-51.75609-1.34338-69.696L822.279,553.6438Z"
          transform="translate(-195.79078 -93.73606)"
          fill={theme.dark}
        />
        <circle cx="602.96442" cy="319.29953" r="23.23247" fill="#ffb6b6" />
        <path
          d="M764.42774,603.80325l-.33908-.11824,4.49682-14.61431a11.90358,11.90358,0,0,1,2.14691-11.09871c-.72728-1.25882-3.72552-7.20329,1.15695-12.25421-.29178-1.47275-1.76016-10.18916,3.36389-14.44987,0,0,9.94242-75.35562,15.51873-95.25953.16154-1.45637-1.14418-13.34567,6.35635-13.81172,3.95582-.24558,9.89228-.62141,18.80116-1.19588,1.15076-.08259,1.82529,1.86094,2.84689,5.024.69163,2.14-2.86727,5.06438-2.0061,5.016l.06076-.004.05893.01565A37.455,37.455,0,0,1,844.58617,489.33l-2.64825,45.02572c.40093,1.81073,8.83647,53.156,6.63136,58.66826-1.25082,3.12631.8819,5.07385,2.439,6.496.80222.73274,1.38179,1.26173,1.301,1.84057a.96543.96543,0,0,1-.60067.70909c-1.40944.70435-.6305,5.53516.19174,8.41481l.08368.294-.27214.13971c-.31434.16117-25.52493-11.40141-56.15281-11.40214C784.01476,599.516,777.34192,608.30808,764.42774,603.80325Z"
          transform="translate(-195.79078 -93.73606)"
          fill={theme.imageHighlight}
        />
        <path
          d="M817.16646,427.31967a1.93506,1.93506,0,0,1-.98668-1.22862l-.33108-1.34869,1.018,1.0609a4.02136,4.02136,0,0,0-1.17732-6.87293,8.43787,8.43787,0,0,0-1.37415-.334,9.51145,9.51145,0,0,1-1.43928-.34708,6.56206,6.56206,0,0,1-3.93836-5.53517,17.38892,17.38892,0,0,1,.68944-6.24316,85.018,85.018,0,0,1-30.84289-.92738,14.31613,14.31613,0,0,1-4.42661-1.74089,17.1477,17.1477,0,0,1-6.05725-6.09436,1.83032,1.83032,0,0,1,.24813-2.15636,1.99125,1.99125,0,0,1,1.44764-.63741l-.37146-1.00451a1.893,1.893,0,0,1,2.12289-2.51655l1.31485.24594-.12625-.87353a1.89212,1.89212,0,0,1,2.53911-2.04249,2.08541,2.08541,0,0,0,2.77668-1.53169l.45223-2.196.04547-.11642c2.22477-3.70588,6.49857-6.4,11.72558-7.39138,4.66163-.88336,9.42077-.43731,14.02456-.00582a12.8401,12.8401,0,0,1,5.60684,1.41635,4.89984,4.89984,0,0,1,2.44451,4.52338c4.53284-1.39379,9.39676,1.38289,11.80125,4.88175,2.85927,4.161,3.32132,9.38112,3.40463,13.46391.19719,9.65071-1.79109,17.54671-5.90881,23.469a5.52949,5.52949,0,0,1-2.54965,2.26624,2.616,2.616,0,0,1-.8437.13607A2.71166,2.71166,0,0,1,817.16646,427.31967Z"
          transform="translate(-195.79078 -93.73606)"
          fill={theme.dark}
        />
        <path
          d="M818.00176,518.79414l-17.05269-10.90552c-10.85886,7.5108-25.53411,33.9708-25.53411,33.9708l-37.14114,34.313a8.93656,8.93656,0,1,0,9.90452,11.87625l51.76259-36.06Z"
          transform="translate(-195.79078 -93.73606)"
          fill="#ffb6b6"
        />
        <path
          d="M816.376,523.21919,827.73342,495.961l-4.1079-15.06363A16.43323,16.43323,0,0,0,810.874,469.138h0a16.39447,16.39447,0,0,0-18.855,12.06325c-3.11067,12.212-5.49952,28.08768.7833,34.3705l.06367.06367Z"
          transform="translate(-195.79078 -93.73606)"
          fill={theme.imageHighlight}
        />
      </svg>
    );
  }
}
